import { render, staticRenderFns } from "./SectionStructure.vue?vue&type=template&id=82005984"
import script from "./SectionStructure.vue?vue&type=script&lang=js"
export * from "./SectionStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports